import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import {
    Dialog, DialogContent, CircularProgress
} from '@material-ui/core';

const loadingStyle = theme => ({
    dialogPaper: {
        backgroundColor: 'transparent', boxShadow: 'none'
    }
});

class Loading extends React.Component {

    render() {
        const { loading, classes } = this.props;

        return (
            <React.Fragment>
            <Dialog
                open={loading}
                classes={{ paper: classes.dialogPaper }}>
                <DialogContent style={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
                    <CircularProgress
                        style={{ display: 'inline-block', backgroundColor: 'transparent' }}
                        size={50}
                        color="primary"
                    />
                </DialogContent>
            </Dialog>
            
            </React.Fragment>
        );

    }
}

Loading.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired
};

export default withStyles(loadingStyle, { withTheme: true })((Loading));



// WEBPACK FOOTER //
// ./src/components/loading.jsx